import React from 'react';
import { ISearchQuery } from './ISearchQuery';
import { useGetWiresIncomingExpectedQuery } from 'API/accounting/AccountingApi';
import { SpinnerTW } from 'tailwindComponents/spinnerTW/SpinnerTW';
import { ExpectedWireTableDisplay } from './ExpectedWireTableDisplay';
import { IPotentialMatch } from './IPotentialMatch';

export interface IExpectedWireSearchProps {
  query: ISearchQuery;
  accountNumber: string;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedWireSearch: React.FC<IExpectedWireSearchProps> = ({ query, accountNumber, setPotentialMatch }) => {
  const { data, isLoading } = useGetWiresIncomingExpectedQuery(query);
  return (
    <>
      {isLoading && <SpinnerTW />}
      {!!data?.content.length && (
        <ExpectedWireTableDisplay data={data} accountNumber={accountNumber} setPotentialMatch={setPotentialMatch} />
      )}
    </>
  );
};
